// extracted by mini-css-extract-plugin
export default {"categoryStructureFramework":"TripTypesFramework_categoryStructureFramework__5WBgg","tripGrid":"TripTypesFramework_tripGrid__0pNAc"};